import { takeLatest, put, all, call } from 'redux-saga/effects';
import {
  getResponse,
  fetchResponseSuccess,
  getResponseByCountry,
  fetchResponseSuccessByCountry,
  getResponseByPackageType,
  fetchResponseSuccessByPackageType,
  getResponseByCoupon,
  fetchResponseSuccessByCoupon,
  getLocation,
  getLocationSuccess,
  onFailure,
  onCouponFailure,
  getTvodResponseByCountry,
  getTvodResponseSuccessByCountry
} from './payment.slice';
import { 
  getResponsePackages, 
  getResponsePackagesByCountry,
  getResponsePackagesByPackageType,
  getUserLocation,
  getTvodPackagesByCountry,
  getResponsePackagesByCoupon
} from './payment.utils';
export function* fetchPayment() {
  try {
    const { data } = yield call(getResponsePackages);

    yield put(fetchResponseSuccess(data));
  } catch (error) {
    yield put(onFailure(error.toString()));
  }
}
export function* fetchPaymentByCountry({ payload }) {
  try {
    const { data } = yield call(getResponsePackagesByCountry, payload);

    yield put(fetchResponseSuccessByCountry(data));
  } catch (error) {
    yield put(onFailure(error.toString()));
  }
}
export function* fetchPaymentByPackageType({ payload }) {
  try {
    const { data } = yield call(getResponsePackagesByPackageType, payload);

    yield put(fetchResponseSuccessByPackageType(data));
  } catch (error) {
    yield put(onFailure(error.toString()));
  }
}
export function* fetchLocation() {
  try {
    const { data } = yield call(getUserLocation);

    yield put(getLocationSuccess(data));
  } catch (error) {
    yield put(onFailure(error.toString()));
  }
}

export function* fechTvodByCountry({ payload }) {
  try {
    const { data } = yield call(getTvodPackagesByCountry, payload);

    yield put(getTvodResponseSuccessByCountry(data));
  } catch (error) {
    yield put(onFailure(error.toString()));
  }
}
export function* fetchPaymentByCoupon({ payload }) {
  try {
    const { data } = yield call(getResponsePackagesByCoupon, payload);

    yield put(fetchResponseSuccessByCoupon(data));
  } catch (error) {
    yield put(onCouponFailure(error?.response?.data?.message));
  }
}

export function* onFetchPayment() {
  yield takeLatest(getResponse.toString(), fetchPayment);
}
export function* onFetchPaymentByCountry() {
  yield takeLatest(getResponseByCountry.toString(), fetchPaymentByCountry);
}
export function* onFetchPaymentByPackageType() {
  yield takeLatest(getResponseByPackageType.toString(), fetchPaymentByPackageType);
}
export function* onfetchLocation() {
  yield takeLatest(getLocation.toString(), fetchLocation);
}
export function* onFechTvodByCountry() {
  yield takeLatest(getTvodResponseByCountry.toString(), fechTvodByCountry);
}
export function* onFetchPaymentByCoupon() {
  yield takeLatest(getResponseByCoupon.toString(), fetchPaymentByCoupon);
}

export function* paymentSagas() {
  yield all([
    call(onFetchPayment),
    call(onFetchPaymentByCountry),
    call(onFetchPaymentByPackageType),
    call(onfetchLocation),
    call(onFechTvodByCountry),
    call(onFetchPaymentByCoupon)
  ]);
}
